import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';

const CODE_LENGTH = new Array(6).fill(0);

const styles = (theme) => ({
  wrap: {
    // display: 'inline-block',
    position: 'relative',
    display: 'flex',
    margin: '20px 0'
  },
  input: {
    position: 'absolute',
    border: 'none',
    fontSize: '32px',
    textAlign: 'center',
    backgroundColor: 'transparent',
    outline: 'none'
  },
  display: {
    border: '1px solid rgba(0, 0, 0, 0.1)',
    width: '32px',
    height: '58px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '32px',
    position: 'relative',
    margin: '5px'
  },

  shadows: {
    position: 'absolute',
    left: 0,
    top: 0,
    bottom: 0,
    right: 0,
    boxShadow: '0 0 0 4px rgba(58, 151, 212, 0.28)'
  }
});

class TwoFactor extends Component {
  input = React.createRef();

  state = {
    value: '',
    focused: false
  };

  handleClick = () => {
    this.input.current.focus();
  };

  handleFocus = () => {
    this.setState({ focused: true });
  };

  handleBlur = () => {
    this.setState({
      focused: false
    });
  };

  handleKeyUp = (e) => {
    if (e.key === 'Backspace') {
      this.setState((state) => {
        return {
          value: state.value.slice(0, state.value.length - 1)
        };
      });
    }
  };

  handleChange = (e) => {
    const { value } = e.target;

    this.setState((state) => {
      if (state.value.length >= CODE_LENGTH.length) return null;
      return {
        value: (state.value + value).slice(0, CODE_LENGTH.length)
      };
    });
  };

  render() {
    const { value, focused } = this.state;

    const { classes } = this.props;

    const values = value.split('');

    const selectedIndex =
      values.length < CODE_LENGTH.length
        ? values.length
        : CODE_LENGTH.length - 1;

    const hideInput = !(values.length < CODE_LENGTH.length);

    return (
      <div className={classes.wrap} onClick={this.handleClick}>
        <input
          ref={this.input}
          className={classes.input}
          onBlur={this.handleBlur}
          onChange={this.handleChange}
          onFocus={this.handleFocus}
          onKeyUp={this.handleKeyUp}
          style={{
            width: '32px',
            top: '0px',
            bottom: '0px',
            left: `${selectedIndex * 32}px`,
            opacity: hideInput ? 0 : 1
          }}
          value=""
        />
        {CODE_LENGTH.map((v, index) => {
          const selected = values.length === index;
          const filled =
            values.length === CODE_LENGTH.length &&
            index === CODE_LENGTH.length - 1;

          return (
            <div key={index} className={classes.display}>
              {values[index]}
              {(selected || filled) && focused && (
                <div className={classes.shadows} />
              )}
            </div>
          );
        })}
      </div>
    );
  }
}

export default withStyles(styles)(TwoFactor);
